import * as Reflux from "reflux";

export default {
    loadFooter: Reflux.createAction("loadFooter") as RefluxAction<[]>
};
